/* ============================================================================
   VILLAINS TCG — Contact (cst-contact.js)
   Progressive enhancement only: shows a loading state on the native Shopify contact
   form's submit button (the form does a full POST + redirect) and guards against a
   double submit. Works fully with JS off — the form is a standard Shopify contact form.
   Re-inits on shopify:section:load for the Theme Editor.
   ========================================================================== */
(() => {
  'use strict';

  const bind = (form) => {
    if (!form || form.dataset.cstBound) return;
    form.dataset.cstBound = '1';
    const btn = form.querySelector('[data-cst-submit]');
    if (!btn) return;
    // The submit event only fires once the browser's native validation passes, so a
    // loading state here always corresponds to a real, valid submission.
    form.addEventListener('submit', () => {
      if (btn.classList.contains('is-loading')) return; // guard against double submit
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    });
  };

  const scan = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-cst-contact-form]').forEach(bind);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (e) => scan(e.target || document));
})();
